import React from 'react';
import { SignUpForm } from 'components';
import styles from './signup.module.scss';
import { useGlobalStateContext } from 'contexts';

function SignUpComponent() {
    const { globalState } = useGlobalStateContext();

    return (
        <div>
            <div className={styles.homeLogo}>
                <img src={globalState.reseller?.logo} alt="Logo"></img>
            </div>
            <SignUpForm />
        </div>
    );
}

export default SignUpComponent;
